"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _isDate = _interopRequireDefault(require("lodash/fp/isDate"));

var relevantValue = function relevantValue(v) {
  return typeof v === 'string' && v.trim() || typeof v === 'number' || typeof v === 'boolean' || (0, _isDate.default)(v);
};

var parametersFilter = function parametersFilter(_ref) {
  var code = _ref.code,
      value = _ref.value;
  return code !== '_manufacturer' && code !== '_warranty' && code !== 'weight' && code !== 'length' && code !== 'width' && code !== 'height' && Boolean(relevantValue(value) || (0, _typeof2.default)(value) === 'object' && relevantValue(value.value));
};

var _default = parametersFilter;
exports.default = _default;